'use client'
import { Button } from '@/components/base/Button'
import { E_CONTENT_HORIZONTAL_ALIGNMENT } from '@/schema'
import { useRouter } from 'next/navigation'
import { memo } from 'react'
import styled, { css } from 'styled-components'

// PENDING UPDATE WITH PROPER typeCms from schema
type ContentTypeButtonLink = {
  columnType: 'button_link'
  horizontalAlignment: E_CONTENT_HORIZONTAL_ALIGNMENT
  text: string
  link?: {
    external: boolean
    href: string
  }
}

interface Props {
  data: ContentTypeButtonLink
}

export const ContentButtonLink = memo(({ data }: Props) => {
  const { text, horizontalAlignment, link } = data
	const { push } = useRouter()

	const onClick = () => {
		if(link?.external) {
			window.open(link?.href, '_blank')
		} else {
			push(link?.href)
		}
	}

  return (
    <ButtonLink className='btn--as-link' onClick={onClick} $xAlign={horizontalAlignment} bgColor='--color-text'>
      {text}
    </ButtonLink>
  )
})

const ButtonLink = styled(Button)<{ $xAlign: Props['data']['horizontalAlignment']}>`
${({ $xAlign }) => $xAlign === E_CONTENT_HORIZONTAL_ALIGNMENT.LEFT ? css`margin-left: 0;` : $xAlign === E_CONTENT_HORIZONTAL_ALIGNMENT.RIGHT ? css`margin-right: 0;` : css`margin: 0 auto;`}
`